import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import { createNamespacedHelpers } from 'vuex'

const TokenStore = createNamespacedHelpers('TokenStore')

Vue.config.productionTip = false

new Vue({
  async mounted () { await this.restoreToken() },
  methods: {
    ...TokenStore.mapActions(['restoreToken'])
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app')
